import { BoxApiGateway } from "@modules/box/services/boxApi.gateway"
import {
  BoxDraftDto,
  BoxDraftDtoSchema,
  BoxDto,
  BoxDtoSchema,
  ItemBoxDto,
  ItemBoxDtoSchema,
} from "@modules/box/services/boxDto"
import { ApiClient } from "@modules/core/api/client/apiClient"

export class BoxApi implements BoxApiGateway {
  private baseUrl = "/boxes"

  constructor(private api: ApiClient) {}

  async getBoxs() {
    const resultDto = await this.api.get<ItemBoxDto[]>(`${this.baseUrl}`)
    return resultDto.data.map((item) => ItemBoxDtoSchema.parse(item))
  }

  async getBox(id: string) {
    const resultDto = await this.api.get<BoxDto>(`${this.baseUrl}/${id}`)
    return BoxDtoSchema.parse(resultDto.data)
  }

  async createBox(box: BoxDraftDto) {
    const resultDto = await this.api.post<BoxDto>(`${this.baseUrl}`, BoxDraftDtoSchema.parse(box))

    return BoxDtoSchema.parse(resultDto.data)
  }

  async updateBox(id: string, box: BoxDraftDto) {
    const resultDto = await this.api.put<BoxDto>(`${this.baseUrl}/${id}`, BoxDraftDtoSchema.parse(box))
    return BoxDtoSchema.parse(resultDto.data)
  }

  async deleteBox(id: string) {
    await this.api.delete<BoxDto>(`${this.baseUrl}/${id}`)
  }
}
